export default function registerComponents(module) {
  // <ichannel-row-header />
  module.component('channelRowHeader', {
    bindings: {
      channel: '=',
      onToggleDetails: '&',
    },
    controllerAs: 'vm',
    controller: function ($scope, $rootScope) {
      'ngInject';

      this.$onInit = () => {
        $scope.c = this.channel; //shortcut for template
        $scope.ff = $rootScope.account.feature_flags;
        $scope.ef = $rootScope.account.extra_features;

        const cs = this.channel.content_settings || {};

        if (cs.preview) {
          this.bgStyle = { 'background-image': `url("${this.channel.content_settings.preview}")` };
        } else {
          this.bgStyle = {};
        }

        this.audioPodcastEnabled = cs.podcast && cs.podcast.audio;
        this.videoPodcastEnabled = cs.podcast && cs.podcast.video;
      };
    },
    template: `
      <div class="row integration-card-header" ng-click="vm.onToggleDetails(c)">
        <div class="hidden-xs col-sm-1" style="width:90px">
          <div class="bg-image-badge"
                ng-style="vm.bgStyle"
                >
          </div>
        </div>
        <div class="hidden-xs col-sm-1" style="width:30px">
          <i ng-hide="c.__isLive" class="fa fa-circle color--grey"></i>
          <i ng-show="c.__isLive" class="fa fa-circle color--online"></i>
        </div>
        <div class="col-sm-5 text-left" style="flex:1">
          <p class="overflow-ellipse body-2" style="margin-bottom:0"><strong>{{c.name}}</strong></p>
          <p class="overflow-ellipse" style="margin-bottom:0"><small>{{c.description}}</small></p>
        </div>
        <div class="hidden-xs col-sm-5 text-right" style="flex:1">
          <ul class="list-inline label-list justify-end">
            <li ng-if="::ef.video_portal && !c.is_private">
              <span class="label label-lagoon">Video Portal Enabled</span>
            </li>
            <li ng-if="c.is_ticketed && c.free_variant && c.free_variant != 'none'">
              <span class="label label-success">Flex (Ticketed HD)</span>
            </li>
            <li ng-if="c.is_ticketed">
              <span class="label label-success">\${{c.ticket_price | number:2}} / ticket</span>
            </li>
            <li ng-if="::ff.podcast && vm.audioPodcastEnabled">
              <span class="label label-podcast">Audio Podcast Enabled</span>
            </li>
            <li ng-if="::ff.podcast && vm.videoPodcastEnabled">
              <span class="label label-podcast">Video Podcast Enabled</span>
            </li>
            <li ng-if="::ff.geoblock && c.content_settings.geoblock">
              <span class="label label-danger">Geoblock Enabled</span>
            </li>
            <li ng-if="::ff.password && c.content_settings.cryptblock">
              <span class="label label-danger">Password Block Enabled</span>
            </li>
            <li ng-if="::ff.host_restrictions && c.content_settings.hostRestrictions">
              <span class="label label-danger">Embedding Restriction Enabled</span>
            </li>
          </ul>
        </div>
        <div class="col-sm-1 text-center">
          <i class="fa fa-chevron-up"></i>
          <i class="fa fa-chevron-down"></i>
        </div>
      </div>
    `,
  });

  // <channel-row-details />
  module.component('channelRowDetails', {
    bindings: {
      channel: '=',
      broadcasts: '=',
      broadcastsPagination: '=',
      loadingBroadcasts: '=',
      pageSize: '=',
      onLoadSelectedBroadcastsForPage: '=',
      onEdit: '&',
      onAddBroadcast: '&',
    },
    controllerAs: 'vm',
    controller: function ($scope, $rootScope) {
      'ngInject';

      this.$onInit = () => {
        $scope.c = this.channel; //shortcut for template
        $scope.ff = $rootScope.account.feature_flags;
        $scope.ef = $rootScope.account.extra_features;
        $scope.canEmbed = $rootScope.user.can('embed', 'broadcast/*');

        this.mediaTokenRestrictions = $rootScope.account.extra_features.media_token_restrictions;
        this.BOXCAST_TV_SHOW_URL = BOXCAST_TV_SHOW_URL;
      };
    },
    template: `
      <div class="channel-row-details row" style="display:block; /*undo flexbox*/">
        <div class="col-xs-12 visible-xs hidden-sm">
          <ul class="list-inline">
            <li ng-if="::ef.video_portal && !c.is_private">
              <span class="label label-lagoon">Video Portal Enabled</span>
            </li>
            <li ng-if="c.is_ticketed && c.free_variant && c.free_variant != 'none'">
              <span class="label label-success">Flex (Ticketed HD)</span>
            </li>
            <li ng-if="c.is_ticketed">
              <span class="label label-success">\${{c.ticket_price | number:2}} / ticket</span>
            </li>
            <li ng-if="::ff.podcast && vm.audioPodcastEnabled">
              <span class="label label-podcast">Audio Podcast Enabled</span>
            </li>
            <li ng-if="::ff.podcast && vm.videoPodcastEnabled">
              <span class="label label-podcast">Video Podcast Enabled</span>
            </li>
            <li ng-if="::ff.geoblock && c.content_settings.geoblock">
              <span class="label label-danger">Geoblock Enabled</span>
            </li>
            <li ng-if="::ff.password && c.content_settings.cryptblock">
              <span class="label label-danger">Password Block Enabled</span>
            </li>
            <li ng-if="::ff.host_restrictions && c.content_settings.hostRestrictions">
              <span class="label label-danger">Embedding Restriction Enabled</span>
            </li>
          </ul>
        </div>
        <div class="col-sm-8">
          <div ng-if="vm.loadingBroadcasts">
            <p class="text-center" style="margin-top:50px">
              <i class="fa fa-spin fa-spinner"></i> Loading...
            </p>
          </div>
          <div ng-if="!vm.loadingBroadcasts && !vm.broadcasts.length">
            <p class="text-center help-block" style="margin-top:30px">
              There are no broadcasts in this channel.
            </p>
            <p class="text-center">
              <button class="btn btn-lg btn-default" ng-click="vm.onAddBroadcast(c)">
                <i style="width:20px" class="fa fa-plus"></i> Add Broadcast
              </button>
            </p>
          </div>
          <div ng-if="!vm.loadingBroadcasts && vm.broadcasts.length">
            <ul class="list-unstyled" style="margin:0 -30px 0 -15px">
              <li ng-repeat="broadcast in vm.broadcasts track by broadcast.id">
                <broadcast-card broadcast="broadcast" show-view-count="false" extra-css-classes="'col-lg-4 col-xxl-3 col-sm-6 col-xs-12'"></broadcast-card>
              </li>
            </ul>
            <div class="clearfix"></div>

            <p ng-if="vm.broadcastsPagination.total > vm.pageSize"
               class="pull-right help-block"
               style="margin-top:24px;">
              <small>
              Showing broadcasts
              {{vm.broadcastsPagination.resultMin}} - {{vm.broadcastsPagination.resultMax}}
              of {{vm.broadcastsPagination.total}}
              </small>
            </p>

            <uib-pagination ng-if="vm.broadcastsPagination.total > vm.pageSize"
                            total-items="vm.broadcastsPagination.total"
                            items-per-page="vm.pageSize"
                            max-size="10"
                            rotate="false"
                            class="pagination-sm"
                            ng-model="vm.broadcastsPagination.current"
                            ng-change="vm.onLoadSelectedBroadcastsForPage(vm.broadcastsPagination.current)"></uib-pagination>

          </div>
        </div>
        <div class="col-sm-4">
          <ul class="list-unstyled" style="margin-top:0">
            <li>
              <button class="btn btn-block btn-primary" ng-click="vm.onEdit(c)" style="text-align:left">
                <i style="width:20px" class="fa fa-edit"></i> Edit Channel Settings
              </button>
            </li>
            <li>
              <p class="text-left help-block" style="font-weight:bold"></p>
              <button class="btn btn-block btn-default" ng-click="vm.onAddBroadcast(c)" style="text-align:left">
                <i style="width:20px" class="fa fa-plus"></i> Add Broadcast
              </button>
            </li>
            <li ng-if="::ff.analytics">
              <p class="text-left help-block" style="font-weight:bold;margin-top:15px;">REPORTS</p>
              <a class="btn btn-block btn-default" ui-sref="reports.viewer({report: 'channels', id: c.id})" style="text-align:left">
                <i style="width:20px" class="fa fa-line-chart"></i> Analytics
              </a>
            </li>
            <li ng-if="c.is_ticketed">
              <p class="text-left help-block" style="font-weight:bold"></p>
              <a class="btn btn-block btn-default" ui-sref="reports.tickets({report: 'channels', id: c.id})" style="text-align:left">
                <i style="width:20px" class="fa fa-ticket"></i> Ticket Report
              </a>
            </li>
            <li ng-if="::canEmbed">
              <p class="text-left help-block" style="font-weight:bold;margin-top:15px;">WATCH</p>
              <a class="btn btn-block btn-default" ui-sref="embed({channel_id: c.id})" style="text-align:left">
                <i style="width:20px" class="fa fa-code"></i> Embed
              </a>
            </li>
            <li ng-if="::!vm.mediaTokenRestrictions">
              <p class="text-left help-block" style="font-weight:bold"></p>
              <a class="btn btn-block btn-default" href="{{vm.BOXCAST_TV_SHOW_URL}}{{c.id}}" target="_blank" style="text-align:left">
                <i style="width:20px" class="fa fa-external-link"></i> View on BoxCast.tv
              </a>
            </li>
          </ul>
        </div>
      </div>
    `,
  });
}



// WEBPACK FOOTER //
// ./app/pages/channels/components.js